module.exports = __webpack_public_path__ + "img/03.3e204122.png";